import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import { provideTransloco as provideTranslocoCore } from "@jsverse/transloco";
import { environment } from "../../../environments/environment";
import { TranslocoLoaderService } from "../services/transloco-loader";

/**
 * Get the browser language or default to French if not supported
 * @returns The language code to use
 */
function getBrowserLanguage(): string {
  const supportedLanguages = ["fr", "en", "es", "de", "cs", "pl"];
  const browserLang = navigator.language?.split("-")[0]; // Get primary language code
  return supportedLanguages.includes(browserLang) ? browserLang : "en";
}

export function provideTransloco(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTranslocoCore({
      config: {
        availableLangs: [
          { id: "fr", label: "Français" },
          { id: "en", label: "English" },
          { id: "es", label: "Español" },
          { id: "de", label: "Deutsch" },
          { id: "cs", label: "Čeština" },
          { id: "pl", label: "Polski" },
        ],
        defaultLang: getBrowserLanguage(),
        reRenderOnLangChange: true,
        prodMode: environment.production,
        fallbackLang: "en",
      },
      loader: TranslocoLoaderService,
    }),
  ]);
}
